import { atom } from "recoil";
import { IAttackingResponse } from "../interfaces/attacking.interface";

export const attacking = atom<IAttackingResponse | null>({
  key: "attacking",
  default: null,
});
